import * as Yup from 'yup';

const isValidButtonUrl = (value: unknown) => {
    const trimmedValue = typeof value === 'string' ? value.trim() : '';

    if (!trimmedValue) {
        return false;
    }

    if (/^[a-zA-Z][a-zA-Z\d+.-]*:/.test(trimmedValue) || trimmedValue.startsWith('//')) {
        try {
            new URL(trimmedValue);
            return true;
        } catch {
            return false;
        }
    }

    return /^(?:\.{1,2}\/|\/)?[^\s?#]+(?:\?[^\s#]*)?(?:#.*)?$/.test(trimmedValue);
};

export const ComponentDetailSchema = Yup.object({
    image: Yup.mixed()
        .nullable()
        .test('fileSize', 'File must be less than 5MB', (value) => {
            if (!value) return true; // No file selected, so we consider it valid
            if (typeof value === 'string') return true;
            return value instanceof File ? value.size <= 5 * 1024 * 1024 : false; // 5MB limit
        }),
    header_title: Yup.string().trim().required('Required').max(100, 'Must be 100 characters or less'),
    header_text: Yup.string().trim().required('Required').max(300, 'Must be 300 characters or less'),
    button_text: Yup.string().trim().required('Required').max(30, 'Must be 30 characters or less'),
    button_link: Yup.string().trim().test('url-or-relative-path', 'Invalid URL', isValidButtonUrl).required('Required'),
    background: Yup.string().nullable(),
});
